import { styled } from "@linaria/react";
import { styleTokens } from "@ideally-ltd/design-tokens";
import { boxShadowToString, hexToRgba } from "helpers/cssColors";

export const ToastProviderStyle = {
  ToastProvider: styled.div`
    .p-toast-message {
      box-shadow: ${boxShadowToString(styleTokens.toast.success.shadow)};
      min-width: ${styleTokens.toast.width};
      border-radius: ${styleTokens.toast.border.radius};
      border: ${styleTokens.toast.border.width} solid black;
      border-width: ${styleTokens.toast.border.width} !important;
      .p-toast-message-content {
        .p-toast-message-icon {
          width: ${styleTokens.toast.icon.size} !important;
          height: ${styleTokens.toast.icon.size} !important;
          margin-top: 3px;
        }
        .p-toast-detail {
          margin-top: ${styleTokens.toast.content.gap};
        }
        .p-toast-summary {
          font-size: ${styleTokens.toast.summary.font.size};
          font-weight: ${styleTokens.toast.summary.font.weight};
        }
        .p-toast-detail {
          font-size: ${styleTokens.toast.detail.font.size};
          font-weight: ${styleTokens.toast.detail.font.weight};
        }
        button.p-toast-icon-close {
          width: ${styleTokens.toast.close.button.width};
          height: ${styleTokens.toast.close.button.height};
          border-radius: ${styleTokens.toast.close.button.border.radius};
        }
      }
    }
    .p-toast .p-toast-message-content {
      align-items: flex-start;
      padding: ${styleTokens.toast.content.padding};
    }
    .p-toast .p-toast-message.p-toast-message-info .p-toast-message-icon {
      color: ${styleTokens.message.info.color};
    }
    .p-toast-message.p-toast-message-info {
      border-color: ${styleTokens.message.info.border.color};
      background-color: ${styleTokens.message.info.background};
      color: ${styleTokens.message.info.color};
      .p-toast-icon-close {
        color: ${styleTokens.message.info.color};
        box-shadow: none !important;
        &:hover,
        &:focus {
          background-color: ${styleTokens.toast.info.close.button.hover.background};
        }
        &:focus,
        &:active {
          border: 2px solid ${styleTokens.toast.info.close.button.focus.ring.color};
        }
      }
    }
    .p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon {
      color: ${styleTokens.message.error.color};
    }
    .p-toast-message.p-toast-message-error {
      border-color: ${styleTokens.message.error.border.color};
      background-color: ${styleTokens.message.error.background};
      color: ${styleTokens.message.error.color};
      .p-toast-icon-close {
        color: ${styleTokens.message.error.color};
        box-shadow: none !important;
        &:hover,
        &:focus {
          background-color: ${styleTokens.toast.error.close.button.hover.background};
        }
        &:focus,
        &:active {
          border: 2px solid ${styleTokens.toast.error.close.button.focus.ring.color};
        }
      }
    }
    .p-toast .p-toast-message.p-toast-message-warn .p-toast-message-icon {
      color: ${styleTokens.message.warn.color};
    }
    .p-toast-message.p-toast-message-warn {
      border-color: ${styleTokens.message.warn.border.color};
      background-color: ${styleTokens.message.warn.background};
      color: ${styleTokens.message.warn.color};
      .p-toast-icon-close {
        color: ${styleTokens.message.warn.color};
        box-shadow: none !important;
        &:hover,
        &:focus {
          background-color: ${styleTokens.toast.warn.close.button.hover.background};
        }
        &:focus,
        &:active {
          border: 2px solid ${styleTokens.toast.warn.close.button.focus.ring.color};
        }
      }
    }

    .p-toast {
      // Baseline z-index
      z-index: 1000;
    }

    .p-toast .p-toast-message.p-toast-message.p-toast-message-success .p-toast-message-icon {
      color: ${styleTokens.message.success.color};
    }
    .p-toast-message.p-toast-message-success {
      border-color: ${styleTokens.message.success.border.color};
      background-color: ${styleTokens.message.success.background};
      color: ${styleTokens.message.success.color};
      .p-toast-icon-close {
        color: ${styleTokens.message.success.color};
        box-shadow: none !important;
        &:hover,
        &:focus {
          background-color: ${styleTokens.toast.success.close.button.hover.background};
        }
        &:focus,
        &:active {
          border: 2px solid ${styleTokens.toast.success.close.button.focus.ring.color};
        }
      }
    }

    // AI TOAST STYLES
    .p-toast-message.p-toast-message-ai {
      border-radius: 4px;
      border: 1px solid ${styleTokens["Ideally-Core"].candy[70]};
      background-color: ${styleTokens.card.background};
      color: ${styleTokens.Surface.Text.main};
    }

    .p-toast-message.p-toast-message-ai:not(.init) {
      animation:
        glow 1000ms ease-in-out 200ms forwards,
        holdGlow 300ms linear 900ms forwards,
        reduceGlow 500ms ease-in-out 2000ms forwards;
    }

    @keyframes glow {
      0% {
        box-shadow: 0 0 8px 5px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.25)};
      }
      100% {
        box-shadow: 0 0 12px 8px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.5)};
      }
    }

    @keyframes holdGlow {
      0% {
        box-shadow: 0 0 12px 8px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.5)};
      }
      100% {
        box-shadow: 0 0 12px 8px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.5)};
      }
    }

    @keyframes reduceGlow {
      0% {
        box-shadow: 0 0 12px 8px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.5)};
      }
      100% {
        box-shadow: 0 0 8px 5px ${hexToRgba(styleTokens["Ideally-Core"].candy[70], 0.25)};
      }
    }
  `,
};
